import script from "./MyAccountStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountStatement.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountStatement.vue?vue&type=style&index=0&id=8d4c4078&lang=css"

const __exports__ = script;

export default __exports__